import React from 'react'

import * as c from '../../../common'

import * as gs from '../../../app/gStyles'

export default React.memo<c.IContractDetailRow>(function ContractDetailRow({
  description,
  notes,
  price,
  qty,
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        margin: 0,
        width: '100%',
      }}
    >
      <p
        style={{
          fontFamily: 'Game',
          margin: 0,
          textAlign: 'center',
          width: '15%',
        }}
      >
        {qty === -1 ? '-' : qty}
      </p>

      <div style={{ ...gs.column, margin: 0, width: '55%' }}>
        <p style={{ ...gs.margin0, fontFamily: 'Game' }}>{description}</p>
        {notes && notes.length > 0 && (
          <>
            {gs.rowGap2}
            {notes.map((noteLine, i) => (
              <p
                key={i}
                style={{ ...gs.margin0, fontFamily: 'Game', marginLeft: 24 }}
              >
                {noteLine}
              </p>
            ))}
          </>
        )}
      </div>

      <p
        style={{
          fontFamily: 'Game',
          margin: 0,
          textAlign: 'end',
          width: '15%',
        }}
      >
        {Intl.NumberFormat('en-US', {
          currency: 'USD',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          style: 'currency',
        }).format(price)}
      </p>

      <p
        style={{
          fontFamily: 'Game',
          margin: 0,
          textAlign: 'end',
          width: '15%',
        }}
      >
        {Intl.NumberFormat('en-US', {
          currency: 'USD',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          style: 'currency',
        }).format(price * (qty === -1 ? 1 : qty))}
      </p>
    </div>
  )
})
